import { $_app_server } from '@/_helpers'

export const publicationService = {
    titleSugestList
  }

  function titleSugestList(type, chunkType, text) {
    return $_app_server.get("public/titlesuggestion?type="+type+"&chunkType="+chunkType+"&text="+text)
      .then(response => {
          return response.data
      })
  }